import $ from 'jquery';
import * as Doka from '../lib/doka/doka.esm.min';
import dateformat from 'dateformat';

import {safeid} from './idtools';

import Events from './events';
import Form from './form';
import Grid from './grid';
import Menu from './menu';


const DIALOG_TITLES = {
  confirm: 'Confirm',
  error: 'Error',
  info: 'Information',
  warning: 'Warning'
};
const DIALOG_ACTIONS = {
  confirm: [{text: 'Yes', id: 'yes'}, {text: 'No', id: 'no'}],
  default: [{text: 'OK', id: 'ok'}]
};
const EMPTY = {'cells': [[]], 'rows': []};
const FORM_SIZES = {
  xxxs: {height: undefined, minWidth: 408, width: '30%'},
  xxs: {height: undefined, minWidth: 544, width: '40%'},
  xs: {height: undefined, minWidth: 680, width: '50%'},
  sm: {height: undefined, minWidth: 816, width: '60%'},
  md: {height: undefined, minWidth: 952, width: '70%'},
  lg: {height: undefined, minWidth: 1088, width: '80%'},
  xl: {height: undefined, minWidth: 1224, width: '90%'},
  'full-screen': {height:  '100%', width: '100%'}
};

const REGEXPS = {
  BACKSLASHES: /\\/g,
  CELL: {
    BGCOLOR_ATTR: / bgcolor="([^"]+)"/gi,
    BODY_TAG: /(<\/?)body( | *>)/gi,
    FACE_ATTR: / face="[^"]+"/gi,
    FALSE_TAG: /<([^/A-Za-z]|\/[^A-Za-z]|\/?$)/g,
    HREF_ATTR: / href="([^"]+)"/gi,
    PATH: /file:\/\/CHI([^"]+)/gi,
    SIZE_ATTR: / size="\d+"/gi
  },
  CHI_HOST: /^(?:(?:.+\.)?ccc-webservices.com|10\.1\.100\.(?:[345]|1[012])|172\.16\.1\.20[678])$/,
  DATE_MASK: /[ /]/g,
  DATEISH: /^\d?\d\/\d?\d\/\d\d(?:\d\d)?$/,
  HTML_FILE_WITH_ANCHOR: /^([^\n]+\.html?)(?:#([^\n]*))?$/i,
  NEWLINES: /\n|\r/g,
  PROPS: /\bcomponents\.chi_[0-9A-Za-z_]+/g,
  RESOURCE_SUBDIRS: /^(?:(?:<appdir>|chi)\/)?(custom\/|html\/|runfiles\/)/,
  SELECTABLE: /\b(row|cell)$/,
  WINDOW_TITLE: / +- +/g
};

function set_safe_id(args) {
  var id = args.id;
  if (Array.isArray(id))
    for (var i = 0, len = id.length; i < len; ++i)
      if (typeof id[i] === 'string')
        id[i] = id[i].trim().toLowerCase();
  args.safe_id = safeid(id);
}

function valid_ref(ref) {
  var node = ref && ref.$el || ref;
  if (node && node instanceof Node && document.contains(node))
    return ref;
}

function get_ref(vm, id, recursing) {
  var parent = vm.$parent;
  var i;
  var ref;
  if (!vm.closed) {
    // check vm
    ref = valid_ref(vm.$refs[id]);
    // check children
    if (!ref && !recursing)
      for (i = vm.$children.length - 1; i >= 0 && !ref; --i) {
        var child = vm.$children[i];
        if (child !== vm && !child.closed)
          ref = valid_ref(child.$refs[id]);
      }
  }
  if (!ref && parent && parent !== vm && !parent.closed) {
    // check siblings
    var siblings = parent.$children;
    if (siblings)
      for (i = siblings.length - 1; i >= 0 && !ref; --i) {
        var sibling = siblings[i];
        if (sibling !== vm && !sibling.closed)
          ref = valid_ref(sibling.$refs[id]);
      }
    // check parent
    if (!ref && !recursing)
      return get_ref(parent, id, true);
  }
  if (ref)
    return ref.$el || ref;
}

function require_ref(self, args, then, props) {
  console.debug('require-ref', self, args, props);
  var id = typeof args.id === 'string' ? args.id : args.id && args.id[0];
  var ref = args.ref || get_ref(self.vm, id);
  if (ref)
    return then.call(self, ref, props || self.$root.get_props(args.safe_id));
  setImmediate(function () {
    ref = get_ref(self.vm, id);
    if (ref)
      return then.call(self, ref, props || self.$root.get_props(args.safe_id));
    self.$root.get_props(args.safe_id).$callbacks.push(function () {
      props = props || self.$root.get_props(args.safe_id);
      ref = props && get_ref(self.vm, id);
      if (ref)
        then.call(self, ref, props);
      else
        console.error('no props/ref "%s"', id, self.vm, props, ref);
    });
  });
}

function update_columns(grid, props, args, type) {
  console.debug('update-columns', this, grid, props, args, type);
  var headers = args['column-headers'];
  var widths = args['column-widths'];
  var width = parseInt(props.width, 10);
  // make the column data structure match the number of columns from the data
  var columns = grid.columns;
  var len = Math.max(headers ? headers.length : 0, widths ? widths.length : 0);
  while (columns.length > len)
    columns.pop();
  while (columns.length < len)
    columns.push({
      field: 'column' + columns.length,
      sort: {compare: Grid.tr_compare[columns.length]},
      template: Grid.td_templates[columns.length]
    });
  // actually set the data
  for (var i = 0, total = 0; i < len; ++i) {
    var column = columns[i];
    if (headers && type === 'headers')
      column.title = headers[i].title || ' ';
    if (widths && type === 'widths') {
      if (args.id === 'multi_book') {
        column.width = [72, 176, 2][i % 3]
        total += column.width;
        column.width = column.width + 'px';
      } else {
        column.width = parseInt(widths[i].width, 10);
        if (width)
          column.width = Math.round(100 * column.width / width, 2) + '%';
      }
    }
  }
  if (args.id === 'multi_book' && total < grid.thead.outerWidth())
    columns.push({width: '*'});
  grid.setOptions({columns: columns});
}

// map array data to object
function chi_row_to_kendo(row, index) {
  var result = {};
  if (row && !row.map) {
    console.warn('invalid chi row "%s"', row);
    return row.column0 !== undefined ? row : result;
  }
  if (row)
    for (var i = row.length - 1; i >= 0; --i) {
      var cell = row[i];
      if (cell.includes('<'))
        cell = cell.replace(REGEXPS.CELL.FALSE_TAG, '&lt;$1');
      if (cell.includes('<')) {
        cell = cell.replace(REGEXPS.CELL.BODY_TAG, '$1span$2');
        cell = cell.replace(
          REGEXPS.CELL.BGCOLOR_ATTR, ' style="background-color: $1"'
        );
        cell = cell.replace(REGEXPS.CELL.FACE_ATTR, ' face="Roboto"');
        cell = cell.replace(REGEXPS.CELL.SIZE_ATTR, ' size="inherit"');
        cell = cell.replace(REGEXPS.CELL.PATH, function (_, resource) {
          resource = resource.replace(REGEXPS.BACKSLASHES, '/').toLowerCase();
          return 'resources' + resource;
        });
        cell = cell.replace(REGEXPS.CELL.HREF_ATTR, ' data-href="$1"');
      }
      result['column' + i] = {content: cell || '&nbsp;', hint: ''};
    }
  result.id = index;
  return result;
}

function windowing_delayed(self, method, args) {
  var form = $('.k-window').last();
  var delay = form.data('windowing-delay');
  if (delay) {
    var now = Date.now();
    if (delay > now) {
      setTimeout(function () {
        form.removeData('windowing-delay');
        method.apply(self, args);
      }, delay - now);
      console.info('windowing event deferred by ' + (delay - now) + 'ms');
      return true;
    } else {
      form.removeData('windowing-delay');
    }
  }
}


// open a dialog
function dialog(args, done) {
  console.debug('dialog', args, this);
  if (this.ignore_next_dialog) {
    setImmediate(done());
    delete this.ignore_next_dialog;
    return console.info('dialog: ignored next');
  }
  if (windowing_delayed(this, dialog, arguments))
    return;  // done() called by delayed method
  var self = this;
  var actions = DIALOG_ACTIONS.default;
  var result = {};
  if (args.buttons && args.buttons.length)
    actions = args.buttons.map(function (button) {
      return {text: button, id: button.toLowerCase()};
    });
  else if (args.type === 'confirm')
    actions = DIALOG_ACTIONS.confirm;
  $('<div id="chi-dialog"></div>')
    .appendTo(document.body)
    .kendoDialog({
      title: DIALOG_TITLES[args.type],
      content: args.text.replace(REGEXPS.NEWLINES, '<br />'),
      actions: actions.map(function (args) {
        return {
          text: args.text,
          action: function () {
            console.debug('dialog: closed with result "%s"', args.id);
            result.id = args.id;
          }
        };
      }),
      open: function () {
        this.wrapper.addClass(`chi-${args.type}-dialog`);
        done();
      },
      close: function () {
        self.$options.socket.emit('close', result);
        this.destroy();
      }
    });
}

// return id of the currently focused component
function focused(_, done) {
  console.debug('focused', this);
  var id = this.$options.api.vm.active_control;
  if (id)
    this.$options.socket.emit('focused', {id: id});
  done();
}

// show or hide the form "loading" spinner
function form_state(args, done) {
  console.debug('form-state', this, args);
  set_safe_id(args);
  var self = this;
  var win = this.$root.windows.peek();
  if (!win || win.last_loading_seq >= args.seq)
    return done();
  win.last_loading_seq = args.seq;
  if (args.loading) {
    kendo.ui.progress($('#' + this.$root.windows.peek().id), args.loading);
  } else {
    var props = this.$root.get_props(args.safe_id);
    if (args.id && props && props.role === 'grid') {
      props.enable_form_callback = function () {
        if (props.enable_form_timeout) {
          clearTimeout(props.enable_form_timeout);
          delete props.enable_form_callback;
          delete props.enable_form_timeout;
          for (var i = self.$root.windows.length - 1; i >= 0; --i)
            kendo.ui.progress($('#' + self.$root.windows[i].id), false);
        }
      };
      if (args.timeout)
        props.enable_form_timeout =
          setTimeout(props.enable_form_callback, args.timeout * 1000);
    } else {
      for (var i = this.$root.windows.length - 1; i >= 0; --i)
        kendo.ui.progress($('#' + this.$root.windows[i].id), false);
    }
  }
  done();
}

// scroll a grid to a cell or row
function grid_scroll(args, done) {
  var selector;
  if (args.bottom !== undefined)
    selector = `tr:eq(${args.bottom})`;
  if (args.left !== undefined)
    selector = `td:eq(${args.left})`;
  if (args.right !== undefined)
    selector = `td:eq(${args.right})`;
  if (args.top !== undefined)
    selector = `tr:eq(${args.top})`;
  require_ref(this, args, function (ref, props) {
    if (props.last_scroll_seq < args.seq) {
      props.last_scroll_seq = args.seq;
      var $ref = $(ref);
      var grid = $ref.data('kendo-grid');
      var target = grid.tbody.find(selector).get(0);
      var container = $ref.find('.k-grid-content').get(0);
      if (target && container)
        grid._scrollTo(target, container);
    }
  });
  done();
}

// return coordinates of currently visible grid cell/row
function grid_scrolled(args, done) {
  args.id = args.id.toLowerCase();
  var result = {id: args.id};
  var socket = this.$root.$options.socket;
  var timed_out = false;
  // backend is waiting for a response, so don't wait indefinitely for a ref
  var timeout = setTimeout(function () {
    timed_out = true;
    socket.emit('grid-scrolled', result);
  }, 2500);
  require_ref(this, args, function (ref) {
    if (timed_out)
      return done();
    var panel = $(ref).children('.k-grid-content');
    var panel_offset = panel.get(0).getBoundingClientRect();
    var rows = panel.find('table>tbody>tr').get();
    var columns = rows[0].children;
    var index, limit, offset;
    if (args.edge === 'bottom') {
      index = rows.length;
      limit = 0;
      do offset = rows[--index].getBoundingClientRect();
      while (index > limit && offset.bottom < panel_offset.bottom);
      result.row = index > limit ? index : 0;
    }
    if (!args.edge || args.edge === 'left') {
      index = -1;
      limit = columns.length;
      do offset = columns[++index].getBoundingClientRect();
      while (index < limit && offset.left < panel_offset.left);
      result.column = index < limit ? index : 0;
    }
    if (args.edge === 'right') {
      index = columns.length;
      limit = 0;
      do offset = columns[--index].getBoundingClientRect();
      while (index > limit && offset.right < panel_offset.right);
      result.column = index > limit ? index : 0;
    }
    if (!args.edge || args.edge === 'top') {
      index = -1;
      limit = rows.length;
      do offset = rows[++index].getBoundingClientRect();
      while (index < limit && offset.top < panel_offset.top);
      result.row = index < limit ? index : 0;
    }
    socket.emit('grid-scrolled', result);
    clearTimeout(timeout);
    done();
  });
}

// select a cell, row, or rows for a grid
function grid_select(args, done) {
  console.debug('grid-select', args, this);
  set_safe_id(args);
  var type;
  var selector;
  if (args.el) {
    type = args.el.prop('tagName') === 'TD' ? 'cell' : 'row';
    selector = args.el;
  } else if (args.cell) {
    type = 'cell';
    selector = `tr:eq(${args.cell[1]})>td:eq(${args.cell[0]})`;
  } else if (args.row !== undefined) {
    type = 'row';
    selector = `tr:eq(${args.row})`;
  } else if (args.rows) {
    type = 'multiple, row';
    selector = args.rows
      .map(function (row) {return `tr:eq(${row})`})
      .join(',');
  }
  if (selector) {
    require_ref(this, args, function (ref, props) {
      if (props.last_select_seq >= args.seq)
        return done && done();
      var $ref = $(ref);
      var grid = $ref.data('kendo-grid');
      var elements = grid.tbody.find(grid.current_selector = selector);
      // make sure the correct elements are selected
      if (!args.el && elements.length) {
        var multiselect = (props.columns && props.columns[0].selectable);
        if (multiselect || props.selectable) {
          var select_type =
            multiselect ? 'rows' :
            props.selectable.replace(REGEXPS.SELECTABLE, '$1s');
          if (select_type === 'cells' && type.endsWith('row'))
            elements = $(elements.get().map(function (element) {
              return element.children[0];
            }));
          else if (select_type === 'rows' && type.endsWith('cell'))
            elements = $(elements.get().map(function (element) {
              return element.parentNode;
            }));
        } else {
          console.error('grid-select: grid not selectable');
        }
        if (args.append)
          elements = elements.add(grid.select());
      }
      if (elements.length) {
        grid.chi_scroll_ok += 2;
        this.vm.$root.apply_grid_selection(grid, elements, this.vm);
        grid.current(elements);
      } else {
        console.warn('grid-select: no elements match selector', selector);
      }
      done && done();
    });
  } else {
    done && done();
  }
}

// return coordinates of selected cell(s) or row(s) for a grid
function grid_selected(args, done) {
  console.debug('grid-selected', args, this);
  set_safe_id(args);
  var result = {id: args.id};
  var timed_out = false;
  var socket = this.$root.$options.socket;
  // backend is waiting for a response, so don't wait indefinitely for a ref
  var timeout = setTimeout(function (socket) {
    timed_out = true;
    socket.emit('select', result);
  }, 2500);
  require_ref(this, args, function (ref, props) {
    if (timed_out)
      return done();
    else
      clearTimeout(timeout);
    if (!props.selectable) {
      console.info('grid-selected: no selectable attribute');
      socket.emit('select', result);
      return done();
    }
    var checkboxes = (props.columns && props.columns[0].selectable);
    var key =
      checkboxes ? 'rows' : props.selectable.replace(REGEXPS.SELECTABLE, '$1s');
    if (!checkboxes && props['selected-' + key]) {
      result[key] = props['selected-' + key];
      delete props['selected-' + key];
    } else {
      var grid = $(ref).data('kendo-grid');
      result[key] = grid ? this.$root.get_grid_selection(grid) : EMPTY[key];
    }
    if (args.type === 'cell') {
      if (key === 'rows') {
        result.cells = result.rows.length ?
          result.rows.map(function (row) {return [0, row]}) : EMPTY.cells;
        delete result.rows;
      } else if (!result.cells.length) {
        result.cells = EMPTY.cells;
      }
    } else if (args.type === 'row' && key === 'cells') {
      result.rows = result.cells.length && result.cells[0].length ?
        result.cells.map(function (cell) {return cell[1]}) : EMPTY.rows;
      delete result.cells;
    }
    socket.emit('select', result);
    done();
  });
}

// close a form
function hide_form(args, done, replace) {
  console.debug('hide-form', this, args, replace);
  var self = this;
  var windows = this.$root.windows;
  if (windows.length < 1) {
    if (replace)
      console.error('hide-form: no forms');
    else
      console.error('hide-form: no form to replace');
    return done();
  }
  if (this.vm.ignore_next_hide_form) {
    this.vm.ignore_next_hide_form = false;
    console.info('hide-form: ignored next');
    return done();
  }
  if (!replace && windows.length < 2) {
    if (windows.length === 1 && windows[0].id.substring(0, 7) === 'wmm0001')
      kendo.ui.progress($('.k-window').last(), true);
    console.info('hide-form: ignoring attempt to close main form');
    return done();
  }
  this.vm.closed = true;
  var fields = windows.peek().fields;
  if (fields)
    for (var i = fields.length - 1; i >= 0; --i)
      delete this.$root.$options.buffer[fields[i]];
  if (windowing_delayed(this, hide_form, arguments))
    return;  // done() called by delayed method
  windows.pop();
  setImmediate(function () {self.$root.activate_previous_window(replace)});
  done(true);
}

// log out entirely
function logout() {
  console.debug('logout', this);
  $.post('/logout');
  this.$root.windows.splice(0);
  this.$root.logout();
}

// download a file
function open_file(args, done) {
  console.debug('open-file', args, this);
  var url =
    (args.file.startsWith('http://') || args.file.startsWith('https://')) ?
    new URL(args.file) : new URL(args.file, window.location);
  url.searchParams.set('T', this.$root.token);
  window.open(url.href, args.name);
  done();
}

// open an html file or url in a new window
function open_window(args, done) {
  var self = this;
  console.debug('open-window', args, this);
  var url =
    (args.url.startsWith('http://') || args.url.startsWith('https://')) ?
    new URL(args.url) : new URL(args.url, window.location);
  if (REGEXPS.CHI_HOST.test(url.hostname))
    url.searchParams.set('T', this.$root.token);
  setTimeout(function (win) {
    if (!(win = window.open(url.href)) || win.outerHeight === 0) {
      console.error('Popup blocker enabled');
    } else {
      win.focus();
      win.onunload = function () {
        console.debug('open-window: window "%s" closed', args.url);
        self.$options.socket.emit('close', {url: args.url});
      };
    }
  }, 250);
  done();
}

// set the top menu, the context menu, or a field-specific context menu
function set_menu(args, done) {
  console.debug('set-menu', args, this);
  set_safe_id(args);
  args.items = Menu.normalize(args.items);
  var root = this.$root;
  var options = root.$options;
  switch (args.ref ? 'default' : args.type) {
  case 'top':
    if (!options.last_topmenu_seq || options.last_topmenu_seq < args.seq) {
      options.last_topmenu_seq = args.seq;
      if (args.items.length && args.items[0].text === 'File')
        args.items.shift();
      root.top_menu_data = args.items;
    }
    done();
    break;
  case 'context':
    if (!options.last_context_seq || options.last_context_seq < args.seq) {
      options.last_context_seq = args.seq;
      var common_options_ignored = false;
      var returntomm = false;
      do {
        var last = args.items.peek() || {};
        if (last.cssClass !== 'chi-menu-divider')
          switch ((last.text || '').toLowerCase()) {
          case 'return to main menu':
            returntomm = true;
            // falls through
          case 'exit':
            break;
          default:
            common_options_ignored = true;
          }
        if (!common_options_ignored)
          args.items.pop();
      } while (!common_options_ignored);
      $('.k-window').last()
        .find('.k-window-titlebar')
        .toggleClass('no-jump-out', !returntomm)
        .toggleClass('no-menu-items', !args.items.length);
      root.context_menu_data = args.items;
    }
    done();
    break;
  case 'grid':
    set_safe_id(args);
    var props = root.get_props(args.safe_id);
    if (!props.last_context_seq || props.last_context_seq < args.seq) {
      props.last_context_seq = args.seq;
      props.select_context_menu = args.items;
    }
    done();
    break;
  case 'field':
  default:
    require_ref(this, args, function (ref, props) {
      if (!props.last_context_seq || props.last_context_seq < args.seq) {
        props.last_context_seq = args.seq;
        var menu = Menu.create_menu(this, $(ref), args.items);
        if (args.grid_id)
          menu.data('last-grid-id', args.grid_id);
        menu = menu.data('kendo-context-menu');
        if (args.timeout)
          setTimeout(function () {menu.close()}, args.timeout);
        menu.open();
      }
    }, args.props);
    done();
    break;
  }
}

// open a file selection dialog
function select_file(args, done) {
  console.debug('select-file', args, this);
  if (windowing_delayed(this, select_file, arguments))
    return;  // done() called by delayed method
  var socket = this.$root.$options.socket;
  var token = this.$root.token;
  $('<div id="chi-dialog"></div>')
    .appendTo(document.body)
    .kendoDialog({
      title: 'Select a File',
      content: '<input name="file" id="file" type="file" />',
      actions: [{
        text: 'Cancel',
        action: function () {socket.emit('file-select', {canceled: true})}
      }],
      open: function () {
        var self = this;
        this.wrapper.addClass('chi-file-dialog');
        this.wrapper
          .children('.k-dialog-titlebar')
          .children('.k-dialog-title')
          .prepend($('<span class="k-icon k-sprite chi-icon-file"></span>'));
        $('#file').kendoUpload({
          async: {saveUrl: 'upload?T=' + token},
          error: function (event) {
            var file = event.files[0];
            console.error('select-file: file "%s" failed to upload', file.name);
            socket.emit('file-upload', {failed: true, name: file.name});
            self.close();
          },
          multiple: false,
          select: function (event) {
            var file = event.files[0];
            console.debug('select-file: file "%s" selected', file.name);
            socket.emit('file-select', {name: file.name});
          },
          success: function (event) {
            var file = event.files[0];
            console.debug('select-file: file "%s" uploaded', file.name);
            socket.emit('file-upload', {name: file.name});
            self.close();
          }
        });
        done();
      },
      close: function () {this.destroy()}
    });
}

// set a field's value or attributes
function set_field_style(context, key, value, then) {
  var seqkey = 'last_' + key + '_seq';
  then = then ? then.bind(this, context.alldone) : context.alldone;
  ++context.count;
  switch (context.args.role) {
  case 'datepicker':
    require_ref(this, context.args, function (ref, props) {
      if (!props[seqkey] || props[seqkey] < context.args.seq) {
        props[seqkey] = context.args.seq;
        $(ref).parent().parent().css(key, value);
      }
      then();
    }, context.props);
    break;
  case 'checkbox':
    require_ref(this, context.args, function (ref, props) {
      if (!props[seqkey] || props[seqkey] < context.args.seq) {
        var $ref = $(ref);
        props[seqkey] = context.args.seq;
        $ref.siblings('[for="' + $ref.attr('id') + '"]').css(key, value);
      }
      then();
    }, context.props);
    break;
  case 'combobox':
    require_ref(this, context.args, function (ref, props) {
      if (!props[seqkey] || props[seqkey] < context.args.seq) {
        props[seqkey] = context.args.seq;
        $(ref).parent().css(key, value);
      }
      then();
    }, context.props);
    break;
  default:
    if (context.args.role !== 'label' && context.props.style) {
      this.vm.$set(context.props.style, key, value);
      then();
    } else {
      require_ref(this, context.args, function (ref) {
        $(ref).css(key, value);
        then();
      }, context.props);
    }
  }
}
function set_field_enabled(context, ref, props, recursing) {
  if (props.last_enable_seq && props.last_enable_seq >= context.args.seq)
    return context.alldone();
  var data_key = KENDO_DATA_KEYS[context.args.role];
  switch (data_key && context.args.role) {
  case 'checkbox':
  case 'floatingbutton':
  case 'grid':
    var component = $(ref).data(data_key);
    if (component) {
      props.last_enable_seq = context.args.seq;
      if (component.enable)
        component.enable(!context.args.disabled);
      else
        console.debug('component does not have enable()', component);
    } else if (recursing === true) {
      console.error('ref is not a kendo root', ref, context.args.role);
    } else {
      return setImmediate(
        set_field_enabled.bind(this, context, ref, props, true)
      );
    }
    break;
  default:
    props.last_enable_seq = context.args.seq;
    $(ref).prop('disabled', context.args.disabled);
  }
  context.alldone();
}
function set_field_focus(context, ref, props) {
  if (
    (context.args.default_focus && !this.vm.default_focus) ||
    (props.last_focus_seq && props.last_focus_seq >= context.args.seq)
  )
    return context.alldone();
  props.last_focus_seq = context.args.seq;
  this.vm.active_control = ref.getAttribute('id');
  var role = context.args.role;
  switch (role) {
  case 'grid':
    var grid = $(ref).data('kendo-grid');
    var current = grid.select();
    if (current.prop('tagName') === 'TR')
      current = current.children().eq(0);
    setImmediate(function () {
      if (grid.tbody)
        grid.tbody.focus();
      grid.current(current);
    });
    break;
  case 'combobox':
    ref = $(ref);
    // falls through
  default:
    // all controls except tabstrips supersede the default focus
    if (role !== 'tabstrip' && role !== 'tablist')
      this.vm.default_focus = false;
    setImmediate(function () {ref.focus()});
  }
  context.alldone();
}
function set_field_maxlength(context, ref, props) {
  if (!props.last_maxlen_seq || props.last_maxlen_seq < context.args.seq) {
    props.last_maxlen_seq = context.args.seq;
    var self = this;
    var $ref = $(ref);
    if (context.args.role !== 'maskedtextbox' && !$ref.data('oninput-set'))
      $ref.on('input', function () {
        if (ref.value.length === context.props.maxlength)
          self.$root.next_field(ref);
      });
    $ref.data('oninput-set', true)
  }
  context.alldone();
}
function set_field_drawpad(context) {
  var self = this;
  function set_drawpad_image() {
    clearTimeout(timeout);
    var drawpad = Doka.find(document.getElementById('doka-root'));
    if (drawpad)
      $.ajax({
        method: 'GET',
        success: function (data) {drawpad.open(data)},
        url:
          context.args.value
            .toLowerCase()
            .replace(REGEXPS.BACKSLASHES, '/')
            .replace(REGEXPS.RESOURCE_SUBDIRS, '/static/resources/$1') +
          '?T=' + self.$root.token,
        xhrFields: {responseType: 'blob'}
      });
  }
  if ($('#drawpad').data('doka-loaded')) {
    set_drawpad_image();
  } else {
    $(document).one('CHI:drawpad-mounted', set_drawpad_image);
    var timeout = setTimeout(function () {
      $(document).off('CHI:drawpad-mounted', set_drawpad_image);
    }, 10000);
  }
  return context.alldone();
}
function set_field_dirty_check(context, value, debug) {
  var field = document.getElementById(context.args.id)
  var fval = field && field.value;
  var pval = context.props.value;
  var rval = fval;
  if (debug) {
    console.debug('>> field? "' + !!field + '"');
    if (field)
      console.debug('>> field.value = "' + field.value + '"');
    console.debug('>> pval = "' + pval + '"');
  }
  // if prop val is set and field val is not, use the argument value
  if (!fval && pval !== undefined && pval !== null)
    return value;
  if (context.props.role === 'maskedtextbox') {
    var umval = this.$root.demask($(field), fval, false);
    console.debug('>> umval = "' + umval + '"');
  }
  if (value instanceof Date) {
    fval = Date.parse(fval);
    pval = Date.parse(pval);
    umval = Date.parse(umval);
    if (debug) {
      console.debug('>> fval = "' + fval + '"');
      console.debug('>> pval = "' + pval + '"');
      console.debug('>> umval = "' + umval + '"');
    }
  }
  // if the field value matches the prop value, or the unmasked field value
  // does, or they're all invalid dates, use the argument value. otherwise hang
  // onto the field value.
  // `==` on purpose, we want type coercion
  return (
    fval == pval || umval == pval ||
    (isNaN(fval) && isNaN(pval) && isNaN(umval))
  ) ? value : rval;
}
function set_field(args, done) {
  function alldone() {
    if (! --count)
      done();
  }
  console.debug('set-field', args, this);
  set_safe_id(args);
  var self = this;
  var props = this.$root.get_props(args.safe_id);
  var count = 0;
  var context = {args, count, alldone, props};
  var set_style = set_field_style.bind(this, context);
  var dirty_check = set_field_dirty_check.bind(this, context);
  if (args.bgcolor !== undefined)
    set_style('background-color', args.bgcolor);
  if (args.color !== undefined)
    set_style('color', args.color);
  if (args.disabled !== undefined && args.role !== 'readonlyfield') {
    ++count;
    require_ref(this, args, set_field_enabled.curry(context), props);
  }
  if (args.default_focus || args.focused !== undefined) {
    ++count;
    require_ref(this, args, set_field_focus.curry(context), props);
  }
  if (args.hidden !== undefined) {
    if (args.id === 'chi-demos') {
      var options = this.$root.$options;
      if (!options.last_demoshow_seq || options.last_demoshow_seq < args.seq) {
        options.last_demoshow_seq = args.seq;
        $('.chi-demos-wrapper').last()
          .removeClass('hovered')
          .toggleClass('clicked', !args.hidden);
      }
    } else {
      if (args.role !== 'label')
        var then = function (done) {
          var label = document.querySelector('label[for="' + args.id + '"]');
          if (label)
            set_field.call(self, {
              ref: label, role: 'label', hidden: args.hidden
            }, done);
        };
      set_style('visibility', args.hidden ? 'hidden' : 'visible', then);
    }
  }
  if (
    args.hint !== undefined &&
    (!props.last_hint_seq || props.last_hint_seq < args.seq)
  ) {
    props.last_hint_seq = args.seq;
    props.hint = args.hint;
  }
  if (args.icon !== undefined) {
    ++count;
    require_ref(this, args, function (ref, props) {
      if (!props.last_icon_seq || props.last_icon_seq < args.seq) {
        props.last_icon_seq = args.seq;
        props.icon = args.icon;
      }
      alldone();
    }, props);
  }
  if (args['max-length'] !== undefined) {
    ++count;
    props.maxlength = +args['max-length'];
    require_ref(this, args, set_field_maxlength.curry(context), props);
  }
  if (
    args.options &&
    (!props.last_options_seq || props.last_options_seq < args.seq)
  ) {
    props.last_options_seq = args.seq;
    props.datasource = args.options.map(function (option) {
      option.value = (option.value || '');
      option.text = (option.text || '');
      return option;
    });
  }
  if (
    args.size !== undefined &&
    (!props.last_size_seq || props.last_size_seq < args.seq)
  ) {
    props.last_size_seq = args.seq;
    props.size = args.size;
  }
  if (args.value !== undefined) {
    function select_value() {
      if (args.id && args.id === self.vm.active_control) {
        var ref = get_ref(self.vm, args.id);
        if (ref)
          ref.select();
      }
    }
    if (
      args.id === 'drawpad' &&
      (!props.last_value_seq || props.last_value_seq < args.seq)
    ) {
      ++count;
      props.last_value_seq = args.seq;
      set_field_drawpad.call(this, context);
    }
    switch (args.role = args.role || args.type) {
    case 'button':
    case 'floatingbutton':
      ++count;
      require_ref(this, args, function (_, props) {
        if (!props.last_value_seq || props.last_value_seq < args.seq) {
          props.last_value_seq = args.seq;
          if (props.hotkey)
            this.vm.hotkeys.remove(props.hotkey, {id: args.id});
          [props.content, props.hotkey] =
            this.vm.hotkeys.apply(args.value, {id: args.id});
        }
        alldone();
      }, props);
      break;
    case 'datepicker':
    case 'calendar':
      if (!props.last_value_seq || props.last_value_seq < args.seq) {
        props.last_value_seq = args.seq;
        props.value =
          isNaN(Date.parse(args.value)) ? null :
          dirty_check(new Date(args.value), true);
        if (args.role === 'datepicker')
          setImmediate(select_value);
      }
      break;
    case 'checkbox':
    case 'radiobuttons':
      if (!props.last_value_seq || props.last_value_seq < args.seq) {
        props.last_value_seq = args.seq;
        props.value = args.value.toLowerCase();
        require_ref(this, args, function (ref, props) {
          var list = $(ref).children('li');
          if (!list.children('input[value="' + props.value + '"]').length)
            list.children('label').is(function () {
              if (this.innerHTML.trim().toLowerCase() === props.value)
                props.value = this.getAttribute('for');
            });
        });
      }
      break;
    case 'htmlarea':
      var matches = args.value.match(REGEXPS.HTML_FILE_WITH_ANCHOR);
      if (matches) {
        if (!props.last_file_seq || props.last_file_seq < args.seq) {
          props.last_file_seq = args.seq;
          props.file = matches[1];
          props.scrollto = (matches[2] || '').trim().toLowerCase();
          require_ref(this, args, function (ref, props) {
            if (
              props.scrollto &&
              (!props.last_anchor_seq || props.last_anchor_seq < args.seq)
            ) {
              props.last_anchor_seq = args.seq;
              var $ref = $(ref);
              var target = $ref.find('a[name="' + props.scrollto + '"]');
              requestAnimationFrame(function () {
                $ref.scrollTop(
                  target.offset().top + $ref.scrollTop() - 6 -
                  $ref.offset().top);
              });
            }
            alldone();
          }, props);
        }
      }
      if (
        !matches && (!props.last_value_seq || props.last_value_seq < args.seq)
      ) {
        props.last_value_seq = args.seq;
        props.template = args.value;
      }
      break;
    case 'maskedtextbox':
      ++count;
      if (!props.last_value_seq || props.last_value_seq < args.seq) {
        props.last_value_seq = args.seq;
        var format;
        if (props.mask === '99/99/99' || props.mask === '00/00/00')
          format = 'mm/dd/yy';
        else if (props.mask === '99/99/9999' || props.mask === '00/00/0000')
          format = 'mm/dd/yyyy';
        if (format && args.value.match(REGEXPS.DATEISH))
          args.value = dateformat(new Date(args.value), format);
        props.value = dirty_check(args.value);
        require_ref(this, args, function (ref) {
          $(ref).data('prev-last-char', '_');
          alldone();
        }, props);
        setImmediate(select_value);
      }
      break;
    case 'narrative':
      if (!props.last_value_seq || props.last_value_seq < args.seq) {
        if (args.value.startsWith('<APPDIR>')) {
          this.$root.$options.socket.emit('register', {
            id: args.id, type: 'narrative', file: args.value
          });
        } else {
          // ensure that all props have at least a buffer entry
          var references = args.value.match(REGEXPS.PROPS);
          if (references)
            references.forEach(function (prop) {
              prop = prop.substr(11);
              if (!(prop in this.components))
                this.components[prop] = this.$root.get_buffer_entry(prop);
            }, this.vm);
          props[args.id[1] + '_template'] = args.value;
          require_ref(this, args, function (ref) {
            this.vm.$nextTick(function () {
              Form.activate_content($(ref), {
                inject: ['components'],
                name: 'NarrativeContent',
                parent: this
              }, true, true);
            });
          })
        }
        props.last_value_seq = args.seq;
      }
      break;
    default:
      if (!props.last_value_seq || props.last_value_seq < args.seq) {
        props.last_value_seq = args.seq;
        props.value = dirty_check(args.value);
        if (args.role === 'textfield' || args.role === 'textarea')
          setImmediate(select_value);
      }
    }
  }
  if (!count)
    done();
}

// set a grid's content or attributes
function apply_grid_hints(grid, args) {
  var ds = grid.dataSource;
  var trs = grid.tbody.get(0).children || [];
  var hints = args.hints;
  for (var i = 0, l = Math.min(ds.total(), hints.length); i < l; ++i) {
    var row = ds.get(i);
    var tds = (trs[i] && trs[i].children) || [];
    //eslint-disable-next-line no-constant-condition
    for (var j = 0; true; ++j) {
      var col = 'column' + j;
      if (!row[col])
        break;
      var hint = row[col].hint = hints[i][j] || '';
      if (tds[j] && tds[j].children && tds[j].children[0])
        tds[j].children[0].setAttribute('title', hint);
    }
  }
}
function set_grid(args, done) {
  function alldone() {
    if (! --count)
      done();
  }
  console.debug('set-grid', JSON.stringify(args), this);
  set_safe_id(args);
  var count = 0;
  var props = this.$root.get_props(args.safe_id);
  var insert = (args.insert !== undefined);
  var update = (args.update !== undefined);
  var prepend = (args.prepend !== undefined);
  var append = (args.append !== undefined);
  if (insert + update + prepend + append > 1) {
    console.error(
      'set-grid: insert/update/prepend/append are mutually exclusive.'
    );
    return done();
  }
  if (args['column-headers']) {
    ++count;
    require_ref(this, args, function (ref, props) {
      console.debug('> args.seq', props.last_header_seq);
      console.debug('> last_header_seq', props.last_header_seq);
      if (!props.last_header_seq || props.last_header_seq < args.seq) {
        props.last_header_seq = args.seq;
        update_columns($(ref).data('kendo-grid'), props, args, 'headers');
      }
      alldone();
    }, props);
  }
  if (args['column-widths']) {
    ++count;
    require_ref(this, args, function (ref, props) {
      console.debug('> args.seq', props.last_header_seq);
      console.debug('> last_widths_seq', props.last_widths_seq);
      if (!props.last_widths_seq || props.last_widths_seq < args.seq) {
        props.last_widths_seq = args.seq;
        update_columns($(ref).data('kendo-grid'), props, args, 'widths');
      }
      alldone();
    }, props);
  }
  if ('hint-file' in args) {
    if (!props.last_hintfile_seq || props.last_hintfile_seq < args.seq) {
      props.last_hintfile_seq = args.seq;
      this.$root.$options.socket.emit('register', {
        id: args.id, type: 'hints', file: args['hint-file']
      });
      props.registered = args['hint-file'];
    }
  }
  if (args.hints) {
    ++count;
    require_ref(this, args, function(ref) {
      if (!props.last_hints_seq || props.last_hints_seq < args.seq) {
        props.last_hints_seq = args.seq;
        apply_grid_hints($(ref).data('kendo-grid'), args);
      }
      alldone();
    }, props);
  }
  if (args.data) {
    ++count;
    if (update) {
      if (args.data.every(function (c) {return !c.trim()}))
        return alldone();
      args.data = chi_row_to_kendo.call(args, args.data, args.update);
    } else if (
      args.data.length === 1 &&
      args.data[0].every(function (c) {return !c.trim()})
    ) {
      args.data = [];
    } else {
      args.data = args.data.map(chi_row_to_kendo, args);
    }
    require_ref(this, args, function (ref, props) {
      if (props.last_data_seq && props.last_data_seq >= args.seq)
        return alldone();
      var $ref = $(ref);
      var grid = $ref.data('kendo-grid');
      var ds = grid.dataSource;
      var i, l;
      grid.element.chi_ignore_next_bind = append || insert || prepend || update;
      if (append) {
        for (i = 0, l = args.data.length; i < l; ++i)
          ds.add(args.data[i]);
        alldone();
      } else if (insert || prepend) {
        var start = args.insert || 0;
        for (i = args.data.length - 1; i >= 0; --i)
          ds.insert(start, args.data[i]);
        alldone();
      } else if (update) {
        var row = ds.at(args.update);
        for (var col in row)
          row.set(col, args.data[col] || row[col]);
        alldone();
      } else /* replace all data */ {
        var selectable =
          props.columns && props.columns[0].selectable ? '' : props.selectable;
        var key = (selectable || '').replace(REGEXPS.SELECTABLE, '$1');
        grid.auto_select_ok = !!key;
        grid.setDataSource({data: args.data, pageable: props.pageable});
        if (!args.data.length)
          return alldone();
        setImmediate(function recurse(self, elements, tries) {
          if (grid.tbody && grid.tbody.children('tr').length === elements)
            requestAnimationFrame(function () {
              if (grid.auto_select_ok && grid.tbody) {
                grid.current_selector = grid.current_selector ||
                  'tr:eq(0)' + (key === 'cell' ? '>td:eq(0)' : '');
                var selection = grid.tbody.find(grid.current_selector);
                self.vm.$root.apply_grid_selection(grid, selection, self.vm);
              }
              alldone();
            });
          else if (tries > 0)
            setImmediate(recurse, self, elements, --tries);
          else
            alldone();
        }, this, args.data.length, 5);
      }
    }, props);
  }
  if (!count)
    done();
}

// manipulate a tab
function find_tab(tabs, args) {
  var tab = typeof args.id[1] === 'number' ? tabs.eq(args.id[1]) : $();
  if (!tab.length)
    tab = tabs.filter('#' + args.id[1]);
  if (!tab.length)
    tab = tabs.filter(function () {
      return $(this).text().trim().toLowerCase() === args.id[1];
    });
  return tab.first();
}
function set_tab(args, done) {
  console.debug('set-tab', args, this);
  set_safe_id(args);
  require_ref(this, args, function (ref, props) {
    var $ref = $(ref);
    var tabstrip = $ref.data('kendo-tab-strip');
    var tab = find_tab(tabstrip.tabGroup.children(), args);
    if (!tab.length) {
      console.error('set-tab: cannot find tab', args.id);
      return done();
    }
    if (args.disabled !== undefined) {
      if (!props.last_enable_seq || props.last_enable_seq < args.seq) {
        props.last_enable_seq = args.seq;
        if (!tab.data('disabled') === !args.disabled) {
          console.info('set-tab: tab already enabled/disabled', args.id);
        } else {
          tabstrip[args.disabled ? 'disable' : 'enable'](tab);
          tab.data('disabled', args.disabled);
        }
      }
    }
    if (args.focused !== undefined) {
      if (!props.last_focus_seq || props.last_focus_seq < args.seq) {
        props.last_focus_seq = args.seq;
        if (tab.data('hidden') || tab.data('disabled')) {
          console.warn('set-tab: cannot focus hidden/disabled tab', args.id);
        } else {
          // if this attribute is present--even if tabstrip animations are
          // turned off--kendo will silently abort the activateTab call
          tabstrip.tabGroup
            .children('[data-animating]')
            .removeAttr('data-animating');
          tabstrip.element.data('api-select-ts', Date.now());
          tabstrip.select(tab);
        }
      }
    }
    if (args.hidden !== undefined) {
      if (!props.last_show_seq || props.last_show_seq < args.seq) {
        props.last_show_seq = args.seq;
        if (!tab.data('hidden') === !args.hidden) {
          console.info('set-tab: tab already hidden/shown', args.id);
        } else {
          tab.css('display', args.hidden ? 'none' : '');
          tab.data('hidden', args.hidden);
        }
      }
    }
    if (args.label !== undefined) {
      props.last_label_seq = props.last_label_seq || {};
      var index = tab.index();
      var seq = props.last_label_seq[index];
      if (!seq || seq < args.seq) {
        props.last_label_seq[index] = args.seq;
        tabstrip.dataSource.at(index).label = args.label;
        tab.children('.k-link').html(args.label);
      }
    }
    done();
  });
}

// set the window title
function set_title(args, done) {
  console.debug('set-title', args, this);
  var win = this.$root.windows.peek() || {};
  if (!win.last_title_seq || win.last_title_seq < args.seq) {
    win.last_title_seq = args.seq;
    win.title = args.title.replace(REGEXPS.WINDOW_TITLE, ' - ');
    if (args.type === 'window')
      window.document.title = this.vm.title = win.title;
  }
  done();
}

// open a new form
function show_form(args, done) {
  console.debug('show-form', args, this);
  var self = this;
  var windows = this.$root.windows;
  var current = windows.peek();
  // if it's trying to show the client menu and there is more than one window
  // open, it probably means it didn't exit cleanly, or the windows got out of
  // sync; either way all the windows need to be closed
  if (args.id === 'wcm0001' && args.replace && windows.length > 1) {
    delete args.replace;
    this.$root.form_operations.splice(
      1, 0,
      hide_form.bind(self, args, done, true),
      show_form.bind(self, args, done)
    );
    for (var i = windows.length; i > 1; --i)
      this.$root.form_operations.splice(1, 0, hide_form.bind(self, args, done));
    return done();
  }
  // clear shared field data every time the user visits the freedom menu
  if (args.id.startsWith('wmm0001'))
    this.$root.shared = {};
  if (current) {
    if (current.id === args.id && !args.replace)
      return done();
    if (args.replace) {
      delete args.replace;
      this.$root.form_operations.splice(
        1, 0,
        hide_form.bind(self, args, done, true),
        show_form.bind(self, args, done)
      );
      return done();
    } else {
      this.vm.background = true;
      $(this.vm.$el)
        .closest('.k-window')
        .off('focus', 'input, select, textarea', Events.on_focus);
      //Object.keys(this.vm.components).forEach(function (key) {
      //  var element = $(this.vm.$refs[key]);
      //  if (KENDO_DATA_KEYS[element.attr('role')])
      //    element.data(KENDO_DATA_KEYS[element.attr('role')]).readonly(true);
      //  else
      //    element.attr('readonly', true);
      //}, this);
    }
  } else if (!this.$root.logged_in) {
    kendo.ui.progress($('#chi-application'), false);
    this.$root.logged_in = true;
  }
  // handle automatic actions registered for this form
  this.$root.window_triggers = this.$root.window_triggers.filter(function (el) {
    var skip = (el.config.skip || {})[args.id];
    var target = (el.config.target || {})[args.id];
    if (skip) {
      skip = skip.bind(self);
      el.config.async ? setImmediate(skip) : skip();
    } else if (target) {
      target = target.bind(self, el.data);
      el.config.async ? setImmediate(target) : target();
      return false;
    }
    return true;
  }, this);
  // create the window
  args.actions = ['hamburger-menu', 'jump-out', 'close', 'context-menu'];
  args.autoFocus = false;
  args.content = `/html/${args.id}.html`;
  if (args.ts !== undefined && !window.dev_mode)
    args.content = `/static/html/${args.ts}.${args.id}.html`;
  args.height = 'auto';
  args.title = this.vm.title;
  args.visible = true;
  args.width = '100%';
  var dimensions = FORM_SIZES[args.size];
  if (dimensions) {
    args.height = dimensions.height;
    args.minWidth = dimensions.minWidth;
    args.width = dimensions.width;
  }
  this.$root.windows.push(args);
  done(true);
}

// show the slyce plugin
function slyce(args, done) {
  console.debug('slyce', args, this);
  var self = this;
  if (windowing_delayed(this, slyce, arguments))
    return;  // done() called by delayed method
  this.ignore_next_dialog = true;
  var slyce = $('<div id="chi-slyce-plugin"></div>');
  slyce.appendTo(document.body).kendoWindow({
    content: 'https://plugin.slycepay.com/?token=' + args.token,
    draggable: false,
    height: 432,
    iframe: true,
    modal: true,
    resizable: false,
    title: 'FMS Payments',
    width: 370,
    activate: function () {
      done();
    },
    close: function () {
      self.$root.$options.socket.emit('close', {id: 'ok'});
      self.ignore_next_dialog = false;
      window.clearTimeout(timeout);
    }
  });
  slyce = slyce.data('kendo-window').center().open();
  var timeout = window.setTimeout(function () {slyce.close()}, 600000);
}


function Api(vm) {
  // operations may depend on the result of other operations to work correctly.
  // this provides a mechanism to buffer an operation until the operation it
  // depends on executes. if an operation is awaiting another operation that
  // never executes, it will never execute either, so critical commands like
  // form open/close should never depend on other operations.
  function handle_deps(self, type, operation) {
    if (parseInt(location.port, 10) >= 8080)
      return operation.bind(self);
    else
      return function (args, done) {
        var callback = function () {
          operation.call(self, args, function (complete_later) {
            // if this operation has dependent(s), call them in order
            var dependents = self.$options.dependents[args.seq];
            if (dependents)
              (function recurse(i) {
                if (i < dependents.length) {
                  setImmediate(function () {
                    dependents[i]();
                    recurse(i + 1);
                  });
                } else {
                  delete self.$options.dependents[args.seq];
                  if (done)
                    done(complete_later);
                }
              })(0);
            else if (done)
              done(complete_later);
          });
          self.$options.recent.enqueue({name: type, seq: args.seq});
        };
        var seq = args.requires;
        if (seq && !self.$options.recent.find(seq)) {
          self.$options.dependents[seq] = self.$options.dependents[seq] || [];
          self.$options.dependents[seq].push(callback);
        } else {
          callback();
        }
      };
  }
  // form operations get queued and executed in order. they only wait for the
  // *previous* form operations to conclude; they do not wait for a *specific*
  // form operation to conclude.
  // they do also need to handle dependencies like non-form operations.
  function queue_form_ops(self, type, operation) {
    operation = handle_deps(self, type, operation);
    var queue = vm.$root.form_operations;
    return function (args) {
      var callback = function () {
        operation.call(self, args, function (complete_later) {
          if (!complete_later)
            queue.operation_complete();
        });
      };
      callback.args = args;
      queue.push(callback);
      if (queue.length === 1)
        queue.next_operation();
    };
  }
  this.events = {
    'dialog': queue_form_ops(this, 'dialog', dialog),
    'focused': queue_form_ops(this, 'focused', focused),
    'form-state': queue_form_ops(this, 'form-state', form_state),
    'grid-scroll': handle_deps(this, 'grid-scroll', grid_scroll),
    'grid-scrolled': queue_form_ops(this, 'grid-scrolled', grid_scrolled),
    'grid-select': handle_deps(this, 'grid-select', grid_select),
    'grid-selected': queue_form_ops(this, 'grid-selected', grid_selected),
    'hide-form': queue_form_ops(this, 'hide-form', hide_form),
    'live-edit': show_form.bind(this),  // development only
    'logout': logout.bind(this),  // never allowed to be queued or deferred
    'open-file': handle_deps(this, 'open-file', open_file),
    'open-window': queue_form_ops(this, 'open-window', open_window),
    'select-file': queue_form_ops(this, 'select-file', select_file),
    'set-menu': queue_form_ops(this, 'set-menu', set_menu),
    'set-field': handle_deps(this, 'set-field', set_field),
    'set-grid': handle_deps(this, 'set-grid', set_grid),
    'set-tab': handle_deps(this, 'set-tab', set_tab),
    'set-title': queue_form_ops(this, 'set-title', set_title),
    'show-form': queue_form_ops(this, 'show-form', show_form),
    'slyce': queue_form_ops(this, 'slyce', slyce)
    // TODO
    // 'close-window': queue_form_ops(this, 'close-window', close_window),
    // 'grid-show': grid_show.bind(this),
    // 'grid-shown': grid_shown.bind(this),
  };
  this.get_ref = get_ref.curry(vm);
  this.queue_form_ops = queue_form_ops;
  this.require_ref = require_ref.curry(this);
  this.vm = vm;
  this.vm_id = vm._uid;
  this.$options = vm.$options;
  this.$root = vm.$root;
}

export default Api;
